'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _filter2 = require('./internal/_filter');

var _filter3 = _interopRequireDefault(_filter2);

var _curry = require('./curry');

var _curry2 = _interopRequireDefault(_curry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function filterNot(predicate, subject) {
  return (0, _filter3.default)(function () {
    return !predicate.apply(undefined, arguments);
  }, subject);
}

/**
 * Remove values for which `predicate` returns `true`.
 *
 * @example
 * // returns List [ 1, 3 ]
 * filterNot(
 *   (n) => n % 2 === 0,
 *   List.of(1, 2, 3)
 * );
 *
 * @param {Function} predicate returns `true` if a value should be excluded.
 * @param {Iterable} subject to filter.
 * @return {Iterable} without values that matched `predicate`.
 */
exports.default = (0, _curry2.default)(filterNot);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/transmute/static-2.3/filterNot.js
// module id = 350
// module chunks = 0 1